import { InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { useModal } from '@ebay/nice-modal-react';
import {
    Button,
    Checkbox,
    ConfigProvider,
    Input,
    Popover,
    Select,
    Space,
    Switch,
    Tag,
    Modal,
} from 'antd';
import { observer } from 'mobx-react';
import { useState } from 'react';
import halfCircleDot from '../../../assets/half-circle-dot.svg';
import Img1 from '../../../assets/wenxian-1.jpg';
import Img2 from '../../../assets/wenxian-2.jpg';
import { useDevice } from '../../../hooks/useDevice';
import { AUTO_LIGHT_TYPES, isDocTypeSupport } from '../const';
import CustomPasteModal from '../CustomPasteModal/index';
import LiteratureSearchModal from '../LiteratureSearchModal/index';
import SelectedLiteratureItem from '../LiteratureSearchModal/SelectedLiteratureItem';
import { summaryStore } from '../store';
import styles from './step1.module.scss';
import ModelSelector from './components/ModelSelector';
import { twMerge } from 'tailwind-merge';
import UploadExcelModal from '../components/UploadExcelModal';
import UploadRisModal from '../components/UploadRisModal';
import { DocType } from '../const';

const Step1 = observer(({ generateOutline }) => {
    const [showAdditionalNote, setShowAdditionalNote] = useState(false);

    const { isMobile } = useDevice();
    const [modal, contextHolder] = Modal.useModal();

    return (
        <>
            <div className="flex h-max w-full flex-col items-start rounded-lg">
                {contextHolder}
                <Space.Compact className={'w-full'}>
                    <Select
                        size="large"
                        className={styles.subjectSelect}
                        options={[
                            {
                                label: 'AI识别学科',
                                value: 'ai-recognized',
                            },
                        ]}
                        placeholder="AI识别学科"
                        value="ai-recognized"
                        style={{
                            width: 160,
                            height: '56px',
                        }}
                    />
                    <Input
                        placeholder="请输入文章题目"
                        size="large"
                        style={{ width: '100%' }}
                        value={summaryStore.majorName}
                        onChange={(e) => summaryStore.changeMajorName(e.target.value)}
                        disabled={summaryStore.isLoadingSummary}
                    />
                </Space.Compact>
                {
                    // 期刊长文和课程长文展示图、表、公式、代码
                    (summaryStore.docType === DocType.TERM_PAPER ||
                        summaryStore.docType === DocType.COURSE_THESIS) && (
                        <div className="flex-col md:flex-row">
                            <div
                                className={
                                    'flex w-full flex-col md:mt-6 md:flex-row md:items-center'
                                }
                            >
                                <div className="mt-6 flex flex-1 gap-3 md:mt-0">
                                    {AUTO_LIGHT_TYPES.map(
                                        ({ value, label, icon, activeIcon, activeUltraIcon }) => {
                                            const isActive =
                                                summaryStore.autoLightTypes.includes(value);

                                            return (
                                                <Tag
                                                    key={value}
                                                    onClick={() => {
                                                        if (summaryStore.isLoadingSummary) return;
                                                        const newTypes =
                                                            summaryStore.autoLightTypes.includes(
                                                                value,
                                                            )
                                                                ? summaryStore.autoLightTypes.filter(
                                                                      (type) => type !== value,
                                                                  )
                                                                : [
                                                                      ...summaryStore.autoLightTypes,
                                                                      value,
                                                                  ];
                                                        summaryStore.onAutoLightChange(newTypes);
                                                    }}
                                                    className={twMerge(
                                                        'flex cursor-pointer items-center gap-1 rounded-md bg-[#F8FBFF] px-2 py-1 md:px-5',
                                                        isActive && 'tag-primary-bg',
                                                        summaryStore.isLoadingSummary &&
                                                            'cursor-not-allowed opacity-60',
                                                    )}
                                                >
                                                    <img
                                                        src={
                                                            isActive
                                                                ? summaryStore.useUltra
                                                                    ? activeUltraIcon
                                                                    : activeIcon
                                                                : icon
                                                        }
                                                        alt={label}
                                                        className="h-4 w-4"
                                                    />
                                                    <span
                                                        className={twMerge(
                                                            'text-sm',
                                                            isActive && 'text-primary',
                                                        )}
                                                    >
                                                        {label}
                                                    </span>
                                                </Tag>
                                            );
                                        },
                                    )}
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
            {/*参考文献标题*/}
            <div className={'mt-7 flex w-full items-center justify-between md:mt-9'}>
                <div className={'flex items-center'}>
                    <img src={halfCircleDot} className={'mr-1.5 h-2.5 w-0.5'} alt="" />
                    <span className={'text-base font-medium text-[#3D3D3D]'}>参考文献</span>
                    <Popover
                        placement="rightTop"
                        trigger={isMobile ? 'click' : 'hover'}
                        content={
                            <div className={'w-[500px] max-w-[90vw]'}>
                                <img className={'mx-auto my-1 w-full'} src={Img1} />
                                <img className={'mx-auto my-1 w-full'} src={Img2} />
                            </div>
                        }
                        title="文献获取指引"
                    >
                        <QuestionCircleOutlined className={'ml-2.5 mr-1'} />
                        <span className={'cursor-default text-xs text-textGray'}>说明</span>
                    </Popover>
                </div>
                {summaryStore.customReference.customReferenceDocument.length ? <Btns /> : null}
            </div>
            {/*文献选择区域*/}
            <div className={'w-full'}>
                <div
                    className={
                        'mt-3 flex w-full flex-col items-center rounded-lg border border-[#EEEEF1] p-3'
                    }
                >
                    <div className={styles.tipTitle}>
                        <InfoCircleOutlined
                            style={{
                                color: 'var(--ant-color-primary)',
                            }}
                        />
                        <span className={'text-xs text-primary'}>
                            参考文献建议 10 条以上，请选择与你全文相关文献，切勿乱选/乱传参考文献
                        </span>
                    </div>

                    {summaryStore.customReference.customReferenceDocument.length ? (
                        <div className={'flex w-full flex-col gap-3'}>
                            {summaryStore.customReference.customReferenceDocument.map((it) => {
                                return (
                                    <SelectedLiteratureItem
                                        key={it.id}
                                        item={it}
                                        onClose={() => {
                                            summaryStore.deletesCustomReferenceDocument(it.id);
                                        }}
                                    />
                                );
                            })}
                        </div>
                    ) : (
                        <Btns />
                    )}
                </div>
            </div>
            {/* 只在毕业论文、期刊论文、课程论文时显示字数和模型选择 */}
            {isDocTypeSupport.wordCountAndModel(summaryStore.docType) && <ModelSelector />}
            {/* 补充说明 */}
            {isDocTypeSupport.additionalInformation(summaryStore.docType) && (
                <div className="flex w-full items-start">
                    <div className="flex items-center gap-2">
                        <Checkbox
                            checked={showAdditionalNote}
                            onChange={(e) => setShowAdditionalNote(e.target.checked)}
                        >
                            <span className="font-semibold text-[#192038]">
                                补充说明
                                {showAdditionalNote ? '：' : ''}
                            </span>
                        </Checkbox>
                    </div>

                    {showAdditionalNote && (
                        <div className="flex-1">
                            <Input.TextArea
                                placeholder="补充相关作者、人物关系、作品简要、实验数据、写作方向等，可更好的帮助生成论文"
                                value={summaryStore.additionalNotes}
                                onChange={(e) => summaryStore.setAdditionalNotes(e.target.value)}
                                maxLength={5000}
                                showCount
                                className="w-full rounded-lg border border-[#E5E6EB] bg-[#F8FBFF]"
                                style={{ resize: 'vertical' }}
                            />
                            {/* autoSize={{ minRows: 3, maxRows: 6 }} */}
                        </div>
                    )}
                </div>
            )}
            <Button
                className="mt-4 h-[56px] w-[240px]"
                shape="round"
                type="primary"
                onClick={() => {
                    modal.confirm({
                        title: '提示',
                        content:
                            '请确认您的大纲和参考文献无误。提交后，生成论文将无法修改大纲和参考文献',
                        okText: '同意',
                        onOk: async () => {
                            generateOutline();
                        },
                    });
                }}
                loading={summaryStore.isLoadingSummary}
            >
                生成大纲
            </Button>
            {isDocTypeSupport.threeOutline(summaryStore.docType) && (
                <div className="mt-4 flex items-center justify-center">
                    <Switch
                        checked={summaryStore.isUseThreeOutline}
                        onChange={(checked) => {
                            summaryStore.setIsUseThreeOutline(checked);
                        }}
                    ></Switch>
                    <div className="ml-1 flex items-center">
                        使用三级大纲
                        <Popover
                            trigger={isMobile ? 'click' : 'hover'}
                            content={
                                <div className="max-w-[300px] text-sm">
                                    <div className="mb-2 font-medium">三级大纲说明：</div>
                                    <div className="text-gray-600">
                                        • 二级大纲：极速简约，结构清晰
                                        <br />
                                        • 三级大纲：内容丰富，深度思考
                                        <br />
                                        <br />
                                        选择三级大纲可以获得更详细的长文结构规划，但生成时间会相应增加。建议重要长文使用三级大纲。
                                    </div>
                                </div>
                            }
                        >
                            <QuestionCircleOutlined className="ml-1" />
                        </Popover>
                    </div>
                </div>
            )}
        </>
    );
});

export const Btns = observer(({ wrap = true }) => {
    const useUploadExcelModal = useModal(UploadExcelModal);
    const useUploadRisModal = useModal(UploadRisModal);
    const useLiteratureSearchModal = useModal(LiteratureSearchModal);
    const useCustomPasteModal = useModal(CustomPasteModal);

    return (
        <Space wrap={wrap}>
            {/* <div className="flex h-[32px] w-[100px] items-center justify-center gap-2 rounded-md border border-solid border-primary px-2">
                <Checkbox
                    checked={summaryStore.isReref}
                    onChange={(e) => {
                        summaryStore.setisReref(e.target.checked);
                    }}
                />
                <span
                    className="cursor-pointer select-none text-sm text-primary"
                    onClick={() => summaryStore.setisReref(!summaryStore.isReref)}
                >
                    推荐文献
                </span>
            </div> */}
            {/* <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: '#34BC43',
                    },
                }}
            >
                <Button
                    color={'primary'}
                    variant={'outlined'}
                    onClick={() => {
                        useLiteratureSearchModal
                            .show({
                                initialSearchValue: summaryStore.majorName,
                            })
                            .then((items) => {
                                summaryStore.addCustomReferenceDocument(items);
                            })
                            .catch(() => {});
                    }}
                >
                    选择文献
                </Button>
            </ConfigProvider> */}
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: '#1E84FF',
                    },
                }}
            >
                <Button
                    color={'primary'}
                    variant={'outlined'}
                    onClick={() => {
                        useCustomPasteModal
                            .show({})
                            .then((items) => {
                                summaryStore.addCustomReferenceDocument(items);
                            })
                            .catch(() => {});
                    }}
                >
                    手动添加
                </Button>
            </ConfigProvider>
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: '#F7941D',
                    },
                }}
            >
                <Button
                    color={'primary'}
                    variant={'outlined'}
                    onClick={() => {
                        useUploadExcelModal.show({}).then((items) => {
                            summaryStore.addCustomReferenceDocument(items);
                        });
                    }}
                >
                    上传excel文献
                </Button>
            </ConfigProvider>
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: '#9C27B0',
                    },
                }}
            >
                <Button
                    color={'primary'}
                    variant={'outlined'}
                    onClick={() => {
                        useUploadRisModal.show({}).then((items) => {
                            summaryStore.addCustomReferenceDocument(items);
                        });
                    }}
                >
                    上传ris文献
                </Button>
            </ConfigProvider>
        </Space>
    );
});

export default Step1;
